export default function Card62(){
    return (
        <div>
            {/*<div className={"text-4xl p-8 bg-gradient-to-r from-indigo-200 via-purple-200 to-pink-200"}>*/}
            {/*    <div className={"text-center font-bold"}>Card 62 :</div>*/}
            {/*</div>*/}
            <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                <div class="max-w-2xl mx-auto text-center mb-10 lg:mb-14">
                    <h2 class="text-2xl font-bold md:text-4xl md:leading-tight dark:text-white">Our leadership</h2>
                </div>
                
                <div class="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    David Forren
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Founder / CEO
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Amil Evara
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    UI/UX Designer
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Ebele Egbuna
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Support Consultant
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Maria Powers
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Director of sales
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Delia Pawelke
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Front-end Developer
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Tom Lowry
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    UI/UX Designer
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Louise Donadieu
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Support Consultant
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Jeff Fisher
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Project Manager
                                </p>
                            </div>
                    </div>

                    <div class="text-center">
                        <img class="rounded-xl sm:size-48 lg:size-60 mx-auto opacity-50" src="https://dummyimage.com/300x300" alt="Description"/>
                            <div class="mt-2 sm:mt-4">
                                <h3 class="text-sm font-medium text-gray-800 sm:text-base lg:text-lg dark:text-gray-200">
                                    Sophia Harrington
                                </h3>
                                <p class="text-xs text-gray-600 sm:text-sm lg:text-base dark:text-gray-400">
                                    Project Manager
                                </p>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    )
}